import OrganizationSwithStorageKeys from "../constant/organizationSwitchStorageKeys";

const KEY = OrganizationSwithStorageKeys.haveShownDialog;

export const organizationSwitchDialogStorage = {
  get() {
    return JSON.parse(localStorage.getItem(KEY) || "false");
  },

  set(value) {
    localStorage.setItem(KEY, JSON.stringify(!!value));
  },

  remove() {
    localStorage.removeItem(KEY);
  }
};
